export class TokenInvasif extends Phaser.GameObjects.Sprite {

    static Types = {
        Frelon: {
            nom: "Frelon Asiatique",
            groupe: 0,
            text: 'frelon'
        },
        Ecrevisse: {
            nom: "Écrevisse de Louisianne",
            groupe: 1,
            text: 'ecrevisseblack'
        },
        Ecureuil: {
            nom: "Écureuil gris",
            groupe: 2,
            text: 'ecureuilgris'
        },
        Caulerpe: {
            nom: "Caulerpe à feuilles d'if",
            groupe: 3,
            text: 'caulerpe'
        },
        Griffe: {
            nom: "Griffe de sorcière",
            groupe: 4,
            text: 'griffesorciere'
        },
        Papillon: {
            nom: "Papillon du palmier",
            groupe: 5,
            text: 'papillon'
        },
        Tortue: {
            nom: "Tortue de Floride",
            groupe: 6,
            text: 'tortue'
        },
        Cynips: {
            nom: "Cynips du châtaignier",
            groupe: 7,
            text: 'cynips'
        }
    }

    /*static Types = {
        Frelon: {
            nom: "Calabrone asiatico",
            groupe: 0,
            text: 'frelon'
        },
        Ecrevisse: {
            nom: "Gambero rosso della Louisiana",
            groupe: 1,
            text: 'ecrevisseblack'
        },
        Ecureuil: {
            nom: "Scoiattolo grigio",
            groupe: 2,
            text: 'ecureuilgris'
        },
        Caulerpe: {
            nom: "Caulerpa",
            groupe: 3,
            text: 'caulerpe'
        },
        Griffe: {
            nom: "Fico degli Ottentotti",
            groupe: 4,
            text: 'griffesorciere'
        },
        Papillon: {
            nom: "Castnide delle palme",
            groupe: 5,
            text: 'papillon'
        },
        Tortue: {
            nom: "Tartaruga palustre americana",
            groupe: 6,
            text: 'tortue'
        },
        Cynips: {
            nom: "Cinipide del castagno",
            groupe: 7,
            text: 'cynips'
        }
    }*/

    constructor(scene, type) {
        super(scene, 0, 0, type.text);
        
        this.setData('token', "invasif");
        this.setData('type', type);
        // scene.add.existing(this);
        // scene.sys.displayList.add(this)
        // scene.sys.updateList.add(this)
    }
}

export class TokenLocal extends Phaser.GameObjects.Sprite {

    static Types = {
        Abeille: {
            nom: "Abeille domestique",
            groupe: 0,
            text: 'abeille'
        },
        Ecrevisse: {
            nom: "Écrevisse à pattes blanches",
            groupe: 1,
            text: 'ecrevisseblanche'
        },
        Ecureuil: {
            nom: "Écureuil roux",
            groupe: 2,
            text: 'ecureuilroux'
        },
        Posidonie: {
            nom: "Posidonie de Méditerranée",
            groupe: 3,
            text: 'posidonie'
        },
        Statice: {
            nom: "Statice nain",
            groupe: 4,
            text: 'statice'
        },
        Palmier: {
            nom: "Palmier nain",
            groupe: 5,
            text: 'palmier'
        },
        Cistude: {
            nom: "Cistude d'Europe",
            groupe: 6,
            text: 'cistude'
        },
        Chataignier: {
            nom: "Châtaignier",
            groupe: 7,
            text: 'chataignier'
        }
    }

    /*static Types = {
        Abeille: {
            nom: "Ape domestica",
            groupe: 0,
            text: 'abeille'
        },
        Ecrevisse: {
            nom: "Gambero di fiume",
            groupe: 1,
            text: 'ecrevisseblanche'
        },
        Ecureuil: {
            nom: "Scoiattolo rosso",
            groupe: 2,
            text: 'ecureuilroux'
        },
        Posidonie: {
            nom: "Posidonia",
            groupe: 3,
            text: 'posidonie'
        },
        Statice: {
            nom: "Statice nano",
            groupe: 4,
            text: 'statice'
        },
        Palmier: {
            nom: "Palma nana",
            groupe: 5,
            text: 'palmier'
        },
        Cistude: {
            nom: "Testuggine palustre europea",
            groupe: 6,
            text: 'cistude'
        },
        Chataignier: {
            nom: "Castagno",
            groupe: 7,
            text: 'chataignier'
        }
    }*/

    constructor(scene, type) {
        super(scene, 0, 0, type.text);

        this.setData('token', "local");
        this.setData('type', type);
        // scene.add.existing(this);
        // scene.sys.displayList.add(this)
        // scene.sys.updateList.add(this)
    }
}

export class TokenAction extends Phaser.GameObjects.Sprite {

    static Types = {
        Proteger: {
            nom: "Protéger",
            groupe: 0,
            text: 'proteger'
        },
        Capturer: {
            nom: "Capturer",
            groupe: 1,
            text: 'capturer'
        },
        Bongeste: {
            nom: "Adopter les bons gestes",
            groupe: 2,
            text: 'bongeste'
        },
        Limiter: {
            nom: "Limiter la propagation",
            groupe: 3,
            text: 'limiter'
        },
        Deraciner: {
            nom: "Déraciner",
            groupe: 4,
            text: 'deraciner'
        },
        Utiliser: {
            nom: "Utiliser des traitements biologiques",
            groupe: 5,
            text: 'utiliser'
        },
        Relacher: {
            nom: "Ne pas relacher",
            groupe: 6,
            text: 'relacher'
        },
        Favoriser: {
            nom: "Favoriser les parasitoïdes",
            groupe: 7,
            text: 'favoriser'
        }
    }

    /*static Types = {
        Proteger: {
            nom: "Proteggere",
            groupe: 0,
            text: 'proteger'
        },
        Capturer: {
            nom: "Catturare",
            groupe: 1,
            text: 'capturer'
        },
        Bongeste: {
            nom: "Adottare gesti corretti",
            groupe: 2,
            text: 'bongeste'
        },
        Limiter: {
            nom: "Limitare la propagazione",
            groupe: 3,
            text: 'limiter'
        },
        Deraciner: {
            nom: "Sradicare",
            groupe: 4,
            text: 'deraciner'
        },
        Utiliser: {
            nom: "Uso di trattamenti biologici",
            groupe: 5,
            text: 'utiliser'
        },
        Relacher: {
            nom: "Non rilasciare",
            groupe: 6,
            text: 'relacher'
        },
        Favoriser: {
            nom: "Favorire i parassitoidi",
            groupe: 7,
            text: 'favoriser'
        }
    }*/

    constructor(scene, type) {
        super(scene, 0, 0, type.text)

        this.setData('token', "action");
        this.setData('type', type);
        // scene.add.existing(this);
        // scene.sys.displayList.add(this)
        // scene.sys.updateList.add(this)
    }
}

export class TokenKata extends Phaser.GameObjects.Sprite {

    constructor(scene,type) {
        super(scene, 0, 0, 'kata')
        this.setData('type', type);
        this.setData('token', "kata");
        // scene.add.existing(this);
        // scene.sys.displayList.add(this)
        // scene.sys.updateList.add(this)
    }
}

export class TokenQuizz extends Phaser.GameObjects.Sprite {

    constructor(scene,type) {
        super(scene, 0, 0, 'quizz')
        this.setData('type', type);
        this.setData('token', "quizz");
        // scene.add.existing(this);
        // scene.sys.displayList.add(this)
        // scene.sys.updateList.add(this)
    }
}


